<template>
  <div class="container-fluid">
    <TheHeader :stationName="viewName" />
    <div class="ps-4 pe-4 pt-3">
      <FoilPeelForm
        :station-id="stationId"
        :url-data="tableUrlFoilPeelData"
      ></FoilPeelForm>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from "vue";
import TheHeader from "@/components/layouts/TheHeader.vue";
import FoilPeelForm from "@/components/foilpeel/FoilPeelForm.vue";

const stationId = 60;
const viewName = "Foil Peel Test";
const tableUrlFoilPeelData = `/Material/GetLastFoilPeel?num=3`;

onMounted(() => {
  document.title = viewName;
});
</script>
